// One scrollbar size for the whole app, wide enough to hit with a mouse; CSS has it as --dx-scrollbar-size.
export const SCROLLBAR_SIZE = 14;
// The visible thumb inside the bar; the margin around it still takes the click.
export const SCROLLBAR_THUMB = 10;

// canvas-datagrid draws its own bars: the same size, with the thumb centred.
export const CANVAS_SCROLLBAR_STYLE = {
  scrollBarWidth: SCROLLBAR_SIZE,
  scrollBarBoxWidth: SCROLLBAR_THUMB,
  scrollBarBoxMargin: (SCROLLBAR_SIZE - SCROLLBAR_THUMB) / 2,
  scrollBarBoxBorderRadius: SCROLLBAR_THUMB / 2
};
